import React from 'react';
import './TeamIntro.css';

export default function TeamIntro() {
  const facts = [
    { number: '15+', label: 'Jaar ervaring' },
    { number: '250+', label: 'Opgeleverde projecten' },
    { number: '98%',  label: 'Tevredenheids­score' },
  ];

  return (
    <section className="teamintro-section text-center">
      <div className="container">
        <h2 className="teamintro-heading mb-4">Maak kennis met ons team</h2>
        <p className="teamintro-text mb-5">
          Ons multidisciplinaire team van marketeers, developers en designers werkt
          dagelijks samen om jouw online zichtbaarheid te vergroten. We geloven in
          transparantie, data-gedreven beslissingen en een flinke dosis plezier.
        </p>

        <div className="row gy-4 justify-content-center">
          {facts.map(({ number, label }, i) => (
            <div key={i} className="col-6 col-md-4 col-lg-3">
              <div className="fact-card h-100">
                <span className="fact-number d-block mb-1">{number}</span>
                <span className="fact-label">{label}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
